export const CREATE = 'create';
export const DELETE = 'delete';
export const CREATE_ACTION_COLOR = 'green';
export const UPDATE_ACTION_COLOR = 'orange';
export const DELETE_ACTION_COLOR = 'red';
export const FILTER_SEGMENT_NAME = 'filter';
export const FILTER_SEGMENT_TITLE = 'Filter';
export const PARENT_PRICE_SHEET_SEGMENT_NAME = 'parent_price_sheet';
export const PARENT_PRICE_SHEET_SEGMENT_TITLE = 'Parent Price Sheet';
export const PDM_INTERNAL = 'PDM Internal';
